import { render, staticRenderFns } from "./DirectPlacementTableForm.vue?vue&type=template&id=df4a0fda"
import script from "./DirectPlacementTableForm.vue?vue&type=script&lang=js"
export * from "./DirectPlacementTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports